module.exports = __webpack_public_path__ + "static/images/classpass-logo.c2340ceab73dee60e670624012877753.svg";